<template>
    <div
        v-if="showNav"
        class="navigationTab"
        :style="{height: addIphonex? '5.4375rem': '3.125rem'}"
    >
        <div
            class="navigationWrapperJD tran"
            @touchmove="onTouchMove"
        >
            <a
                href="//pro.m.jd.com/mall/active/3JAoyewPmdVBMeRWTBiHDdGH5M36/index.html"
                class="columnjd shopping-columnjd"
                :clstag="'jr|keycount|yxsc_navigation|3c'"
            >
                <p><img
                        :src="ccc"
                        alt=""
                        class="shoppingjd-icon"
                        lazy="loaded"
                    ></p>
            </a>
            <a
                href="//pro.m.jd.com/mall/active/33i82xZj8B1t8WQbpi4k8eVX4Y47/index.html"
                class="columnjd discover-columnjd"
                :clstag="'jr|keycount|yxsc_navigation|tideBoy'"
            >
                <p><img
                        :src="tideBoy"
                        alt=""
                        class="shoppingjd-icon"
                    ></p>
            </a>
            <a
                href="//pro.m.jd.com/mall/active/2NdXJj1rHP53oF2u9cEM8RByRjaP/index.html"
                class="columnjd discover-columnjd"
                :clstag="'jr|keycount|yxsc_navigation|tech'"
            >
                <p><img
                        :src="tech"
                        alt=""
                        class="shoppingjd-icon"
                    ></p>
            </a>
            <a
                href="javascript:void(0);"
                class="columnjd me-columnjd"
                :clstag="'jr|keycount|yxsc_navigation|enjoy'"
            >
                <p><img
                        :src="enjoyP"
                        alt=""
                        class="shoppingjd-icon"
                    ></p>
            </a>
            <a
                href="//pro.m.jd.com/mall/active/Bs2xE7KmE7BWVEdHudkbqnanu9Z/index.html"
                class="columnjd me-columnjd"
                :clstag="'jr|keycount|yxsc_navigation|sport'"
            >
                <p><img
                        :src="sport"
                        alt=""
                        class="shoppingjd-icon"
                    ></p>
            </a>
        </div>
        <div
            v-if="addIphonex"
            class="addIphonex"
        ></div>
    </div>
</template>
<script type="text/ecmascript-6">
import KPL from '@/buscomponents/KPL.vue';
import { isIphonex } from '@/util/common';
import './../scss/mixin.scss';
// img12.360buyimg.com/jrpmobile/jfs/t1/20265/4/5704/5992/5c406c60E15c9df5d/cc6ec0966de84bf0.png
export default {
    name: 'BUSNavigation',
    components: {
        KPL
    },
    props: {
        isShow: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            currentActive: 'shopping-active',
            ccc: '//m.360buyimg.com/babel/jfs/t18952/224/2412573969/2922/f5c1863a/5af2f24fNf222e0f7.jpg',
            tideBoy: '//m.360buyimg.com/babel/jfs/t17887/207/2630680451/6188/8db23770/5b052402N4d7576ea.png',
            tech: '//m.360buyimg.com/babel/jfs/t16456/15/2458787626/6535/639f0aa1/5aab5590N8f7b6c58.png',
            enjoyP: '//img12.360buyimg.com/jrpmobile/jfs/t1/56558/3/1318/5726/5cf09d04E233e5b1a/1a14be43514d931c.png',
            sport: '//m.360buyimg.com/babel/jfs/t21223/31/239941359/6449/f589b1b7/5b053a0eN8e3d3020.png',
            link: 'https://p.m.jd.com/cart/cart.action',
            showNav: false,
            fixedHeight: isIphonex() ? 'XphoneInsetHeight' : '',
            addIphonex: isIphonex() ? true : false
        };
    },
    mounted() {
        let delay = 10;
        setTimeout(() => {
            this._initInstance();
        }, delay);
    },
    destroyed() {
        this.$refs.kplIns = null;
        this.$refs = null;
        this._self = null;
    },
    methods: {
        _initInstance() {
            const hash = window.location.hash.replace('#/', '');
            this.showNav = this.isShow;
            switch (hash) {
                case 'shoppingcart':
                    this.currentActive = 'shoppingcart-active';
                    break;
                case 'me':
                    this.meIcon = '//img12.360buyimg.com/jrpmobile/jfs/t25648/207/1283866757/1308/bc44d2c4/5b91014dNf6583e0a.png';
                    this.currentActive = 'me-active';
                    break;
                case 'DiscoverPage':
                    // this.discoverIcon = './images/discover_active.png';
                    // this.currentActive = 'discover-active';
                    // if ($.device && $.device.weixin) {
                    //   this.showNav = false;
                    // }
                    break;
                default:
                    this.shoppingIcon = '//img12.360buyimg.com/jrpmobile/jfs/t26077/278/1307571349/1314/332595be/5b91014dN148b4352.png';
                    this.currentActive = 'shopping-active';
                    break;
            }
        },
        show() {
            this.showNav = true;
        },
        hide() {
            this.showNav = false;
        },
        onTouchMove(e) {
            e.preventDefault();
        }
    }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';

.navigationTab {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    width: 100%;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 -3px 10px 0 hsla(0, 0%, 78%, 0.2);
    height: $rem100;
}
.navigationWrapperJD {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    height: $rem100;
    width: 100%;
    overflow: hidden;
    background: #ffffff;
    flex-direction: row;
    box-shadow: 0 -3px 10px 0 hsla(0, 0%, 78%, 0.2);
    display: flex;
    flex: 1;
}

.XphoneInsetHeight {
    height: $rem168;
    padding-bottom: $rem68;
}
.addIphonex {
    height: $rem54;
    background: #ffffff;
    position: absolute;
    left: 0;
    top: 0;
}
.columnjd {
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    text-align: center;
    .shopping-icon,
    .shopping-cart,
    .shopping-me,
    .discover-active {
        height: 100%;
    }

    .textjd {
        margin-top: $rem10;
        font-size: $rem20;
        color: #666666;
        text-align: center;
        font-family: PingFangSC-Regular;
    }

    img {
        // width: $rem40;
        height: $rem100;
    }
}

.shopping-active {
    .shopping-columnjd {
        .text {
            color: #4191ff;
        }
    }
}

.me-active {
    .me-columnjd {
        .text {
            color: #4191ff;
        }
    }
}

.shoppingcart-active {
    .shoppingcart-columnjd {
        .text {
            color: #4191ff;
        }
    }
}

.discover-active {
    .discover-columnjd {
        .text {
            color: #4191ff;
        }
    }
}
.textjd-p {
    color: #4191ff !important;
    text-align: center;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
    transition: all 0.6s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(100%);
    opacity: 0;
}
</style>
